import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i426735141__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        stroke: "currentColor",
        d: "M13.457 2.094a8.22 8.22 0 0 1-4.44 15.125c-4.523.01-8.229-3.68-8.236-8.205a8.218 8.218 0 0 1 3.76-6.92l.06.106A8.112 8.112 0 0 0 .906 9c0 4.493 3.647 8.094 8.094 8.094 4.493 0 8.094-3.647 8.094-8.094a8.075 8.075 0 0 0-3.698-6.796l.061-.11ZM9.063.5v9.125h-.125V.5h.125Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i426735141__a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }